export default class IdStringRequest {
    id: string
    param: string
}